import { CURR_NEWS_ADD, CURR_NEWS_DEL } from "../actions/curr_news_actions";


const initialState = {
  news: {}
}

export const currNewsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CURR_NEWS_ADD: {
      return {
        ...state,
        news: {...action.news}
      }
    }
    case CURR_NEWS_DEL: {
      return {
        ...state,
        news: {}
      }
    }
    default: return state;
  }
}
